import { render, staticRenderFns } from "./conferences_types.vue?vue&type=template&id=7795ec36"
import script from "./conferences_types.vue?vue&type=script&lang=js"
export * from "./conferences_types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports